import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';

export interface AddEditorsPickPayload {
  locationId: string;
  clubId: string;
  description: string;
  tags: string;
}

export interface UpdateEditorsPickPayload {
  editorPickId: string;
  description: string;
  tags: string;
}

export interface DeleteEditorsPickPayload {
  editorPickId: string;
}

const addEditorsPick = (client: AxiosInstance) => async (payload: AddEditorsPickPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.ADD_EDITORS_PICK, payload)).data;
};

const updateEditorsPick = (client: AxiosInstance) => async (payload: UpdateEditorsPickPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.UPDATE_EDITORS_PICK, payload)).data;
};

const deleteEditorsPick = (client: AxiosInstance) => async (payload: DeleteEditorsPickPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.DELETE_EDITORS_PICK, payload)).data;
};

export const editorsPickMutations = {
  addEditorsPick,
  updateEditorsPick,
  deleteEditorsPick,
};
